import UtilsSchema from "@repoflow/schema/utils";

import {
  limitId,
  pointId,
  description,
  limits,
  dimensions,
  createdAt,
  updatedAt
} from "./fields";

export default [
  ...UtilsSchema,
  {
    id: "/Public/PointLimit",
    type: "object",
    properties: {
      limitId,
      pointId,
      description,
      limits,
      dimensions,
      createdAt,
      updatedAt
    }
  },
  {
    id: "/Public/PointLimit/Create",
    type: "object",
    properties: {
      description,
      limits,
      dimensions,
    },
    // `description` is already `String!` on PointLimitInputCreate — see the note
    // in ../point/public.js. `dimensions` is deliberately NOT required: a limit
    // with no dimensions is a single quota over the whole point, which is a
    // legitimate shape and produces the empty composite value id.
    required: ["description"],
  },
  {
    id: "/Public/PointLimit/Update",
    type: "object",
    properties: {
      description,
      limits,
      dimensions,
    },
    required: ["description"],
  }
];
